import React from 'react';
import {
  useGlobalLocaleContext,
  useGlobalTimeSliderContext,
  useTimePointSelectorContext,
} from '../../../context/contexts';
import { TimeSliderPoint } from './TimeSliderPoint';
import { TimeSliderRange } from './TimeSliderRange';
import { TimeSliderTypes } from './types';

interface TimeSliderProps {
  type: TimeSliderTypes;
}

export const TimeSlider = (props: TimeSliderProps) => {
  const timeSliderRangeHandle = useGlobalTimeSliderContext();
  const timePointSelectorHandle = useTimePointSelectorContext();
  const locale = useGlobalLocaleContext();
  const { type } = props;
  if (type === TimeSliderTypes.RANGE) {
    return (
      <TimeSliderRange
        timeSliderRangeHandle={timeSliderRangeHandle}
        selectedLanguage={locale.selected}
      />
    );
  } else {
    return (
      <TimeSliderPoint
        timePointSelectorHandle={timePointSelectorHandle}
        selectedLanguage={locale.selected}
      />
    );
  }
};
